<div *ngIf="showSlant" class="underlay"></div>
<nav class="navbar navbar-expand-sm navbar-dark bg-blue-400">
  <div class="container">

    <a class="navbar-brand" [routerLink]="['/']">
      <svg class="logo" fill="currentcolor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" width="80px"
        height="80px">
        <path
          d="M 46 5 C 44.355469 5 43 6.355469 43 8 L 43 12.417969 C 42.65625 12.277344 42.386719 12 42 12 L 35 12 C 33.355469 12 32 13.355469 32 15 L 32 15.402344 C 31.929688 15.375 31.863281 15.339844 31.789063 15.316406 L 26.96875 13.996094 C 25.378906 13.558594 23.714844 14.507813 23.28125 16.09375 L 14.8125 46.953125 C 14.503906 48.09375 14.910156 49.265625 15.75 50 L 9 50 C 7.90625 50 7 50.90625 7 52 L 7 59 C 7 60.09375 7.90625 61 9 61 L 16 61 L 16 67 C 16 69.199219 17.800781 71 20 71 C 22.199219 71 24 69.199219 24 67 L 24 61 L 58 61 L 58 67 C 58 69.199219 59.800781 71 62 71 C 64.199219 71 66 69.199219 66 67 L 66 61 L 73 61 C 74.09375 61 75 60.09375 75 59 L 75 52 C 75 50.90625 74.09375 50 73 50 L 68.8125 50 C 68.925781 49.683594 69 49.351563 69 49 L 69 23 C 69 21.355469 67.644531 20 66 20 L 59 20 C 58.613281 20 58.34375 20.277344 58 20.417969 L 58 8 C 58 6.355469 56.644531 5 55 5 Z M 46 7 L 55 7 C 55.566406 7 56 7.433594 56 8 L 56 23 L 58 23 C 58 22.433594 58.433594 22 59 22 L 66 22 C 66.566406 22 67 22.433594 67 23 L 67 49 C 67 49.566406 66.566406 50 66 50 L 59 50 C 58.433594 50 58 49.566406 58 49 L 56 49 C 56 49.566406 55.566406 50 55 50 L 46 50 C 45.433594 50 45 49.566406 45 49 L 43 49 C 43 49.566406 42.566406 50 42 50 L 35 50 C 34.433594 50 34 49.566406 34 49 L 34 15 C 34 14.433594 34.433594 14 35 14 L 42 14 C 42.566406 14 43 14.433594 43 15 L 45 15 L 45 8 C 45 7.433594 45.433594 7 46 7 Z M 47 10 L 47 12 L 54 12 L 54 10 Z M 26.035156 15.894531 C 26.167969 15.878906 26.300781 15.886719 26.4375 15.921875 L 31.261719 17.246094 C 31.804688 17.394531 32.109375 17.929688 31.957031 18.472656 L 23.496094 49.335938 C 23.402344 49.671875 23.15625 49.894531 22.859375 50 L 22.136719 50 L 17.441406 48.714844 C 16.898438 48.5625 16.59375 48.027344 16.742188 47.484375 L 25.207031 16.625 C 25.320313 16.214844 25.648438 15.941406 26.035156 15.894531 Z M 36 16 L 36 18 L 41 18 L 41 16 Z M 44 17 C 43.449219 17 43 17.449219 43 18 C 43 18.550781 43.449219 19 44 19 C 44.550781 19 45 18.550781 45 18 C 45 17.449219 44.550781 17 44 17 Z M 26.503906 19.359375 L 25.96875 21.28125 L 28.875 22.097656 L 29.417969 20.171875 Z M 44 21 C 43.449219 21 43 21.449219 43 22 C 43 22.550781 43.449219 23 44 23 C 44.550781 23 45 22.550781 45 22 C 45 21.449219 44.550781 21 44 21 Z M 44 25 C 43.449219 25 43 25.449219 43 26 C 43 26.550781 43.449219 27 44 27 C 44.550781 27 45 26.550781 45 26 C 45 25.449219 44.550781 25 44 25 Z M 57 25 C 56.449219 25 56 25.449219 56 26 C 56 26.550781 56.449219 27 57 27 C 57.550781 27 58 26.550781 58 26 C 58 25.449219 57.550781 25 57 25 Z M 60 25 L 60 27 L 65 27 L 65 25 Z M 32 25.886719 L 32 49 C 32 49.351563 32.074219 49.683594 32.1875 50 L 25.371094 50 C 25.382813 49.953125 25.410156 49.914063 25.421875 49.863281 Z M 44 29 C 43.449219 29 43 29.449219 43 30 C 43 30.550781 43.449219 31 44 31 C 44.550781 31 45 30.550781 45 30 C 45 29.449219 44.550781 29 44 29 Z M 57 29 C 56.449219 29 56 29.449219 56 30 C 56 30.550781 56.449219 31 57 31 C 57.550781 31 58 30.550781 58 30 C 58 29.449219 57.550781 29 57 29 Z M 44 33 C 43.449219 33 43 33.449219 43 34 C 43 34.550781 43.449219 35 44 35 C 44.550781 35 45 34.550781 45 34 C 45 33.449219 44.550781 33 44 33 Z M 57 33 C 56.449219 33 56 33.449219 56 34 C 56 34.550781 56.449219 35 57 35 C 57.550781 35 58 34.550781 58 34 C 58 33.449219 57.550781 33 57 33 Z M 44 37 C 43.449219 37 43 37.449219 43 38 C 43 38.550781 43.449219 39 44 39 C 44.550781 39 45 38.550781 45 38 C 45 37.449219 44.550781 37 44 37 Z M 57 37 C 56.449219 37 56 37.449219 56 38 C 56 38.550781 56.449219 39 57 39 C 57.550781 39 58 38.550781 58 38 C 58 37.449219 57.550781 37 57 37 Z M 44 41 C 43.449219 41 43 41.449219 43 42 C 43 42.550781 43.449219 43 44 43 C 44.550781 43 45 42.550781 45 42 C 45 41.449219 44.550781 41 44 41 Z M 57 41 C 56.449219 41 56 41.449219 56 42 C 56 42.550781 56.449219 43 57 43 C 57.550781 43 58 42.550781 58 42 C 58 41.449219 57.550781 41 57 41 Z M 19.765625 44.050781 L 19.222656 45.980469 L 22.128906 46.792969 L 22.671875 44.871094 Z M 36 45 L 36 47 L 41 47 L 41 45 Z M 44 45 C 43.449219 45 43 45.449219 43 46 C 43 46.550781 43.449219 47 44 47 C 44.550781 47 45 46.550781 45 46 C 45 45.449219 44.550781 45 44 45 Z M 47 45 L 47 47 L 54 47 L 54 45 Z M 57 45 C 56.449219 45 56 45.449219 56 46 C 56 46.550781 56.449219 47 57 47 C 57.550781 47 58 46.550781 58 46 C 58 45.449219 57.550781 45 57 45 Z M 60 45 L 60 47 L 65 47 L 65 45 Z M 9 52 L 21.949219 52 C 22.339844 52.078125 22.726563 52.074219 23.101563 52 L 73 52 L 73 59 L 64 59 L 64 67 C 64 68.117188 63.117188 69 62 69 C 60.882813 69 60 68.117188 60 67 L 60 59 L 22 59 L 22 67 C 22 68.117188 21.117188 69 20 69 C 18.882813 69 18 68.117188 18 67 L 18 59 L 9 59 Z M 20 59 C 19.449219 59 19 59.449219 19 60 C 19 60.550781 19.449219 61 20 61 C 20.550781 61 21 60.550781 21 60 C 21 59.449219 20.550781 59 20 59 Z M 62 59 C 61.449219 59 61 59.449219 61 60 C 61 60.550781 61.449219 61 62 61 C 62.550781 61 63 60.550781 63 60 C 63 59.449219 62.550781 59 62 59 Z" />
      </svg>
      <span class="d-none d-lg-inline-block">{{ 'app' | translate }}</span>
    </a>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div *ngIf="user" class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/invoices']">
            <span class="link-text">{{ prefix + 'invoices' |  translate }}</span>
            <span class="sr-only">{{ 'common.current' | translate }}</span></a>
        </li>

        <li class="nav-item" class="d-none d-lg-inline-block" routerLinkActive="active">
          <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">
            <span class="link-text">{{ prefix + 'expenses' | translate }}</span>
          </a>
        </li>

        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/contacts']">
            <span class="link-text">{{ prefix + 'contacts' | translate }}</span>
          </a>
        </li>

        <li class="nav-item" class="d-none d-lg-inline-block">
          <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">
            <span class="link-text">{{ prefix + 'support' | translate }}</span>
          </a>
        </li>
      </ul>

      <ul class="navbar-nav position-relative">
        <li class="nav-item" dropdown placement="bottom right">
          <a class="nav-link user-button d-flex" dropdownToggle href="javascript:void(0)" role="button"
            aria-disabled="true">
            <span class="text-right align-self-center">
              <div class="text-white team-name">{{ team.name }}</div>
              <div class="text-gray-300 user-name">{{ user.name }}</div>
            </span>
            <img [src]="imgSrc" class="ml-3 avatar bg-blue-100" />
          </a>
          <ul *dropdownMenu class="user-menu dropdown-menu dropdown-menu-right" role="menu">

            <li role="menuitem">
              <a class="dropdown-item d-flex align-items-center" [routerLink]="['/profile/me']">
                <div class="row">
                  <div class="col-auto pt-1 pr-0">
                    <i class="material-icons text-gray-600">perm_identity</i>
                  </div>
                  <div class="col">
                    <div><strong>{{ prefix + 'my-profile' | translate }}</strong></div>
                    <div class="item-text">{{ prefix + 'my-profile-text' | translate }}</div>
                  </div>
                </div>
              </a>
            </li>

            <li role="menuitem">
              <a class="dropdown-item d-flex align-items-center" [routerLink]="['/profile/team']">
                <div class="row">
                  <div class="col-auto pt-1 pr-0">
                    <i class="material-icons text-gray-600">group</i>
                  </div>
                  <div class="col">
                    <div><strong>{{ prefix + 'my-team' | translate }}</strong></div>
                    <div class="item-text">{{ prefix + 'my-team-text' | translate }}</div>
                  </div>
                </div>
              </a>
            </li>

            <!-- <li role="menuitem">
              <a class="dropdown-item d-flex align-items-center sub-item" [routerLink]="['/profile/companies']">
                <div><strong>{{ prefix + 'companies' | translate }}</strong></div>
              </a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item d-flex align-items-center sub-item" [routerLink]="['/profile/bank-accounts']">
                <div><strong>{{ prefix + 'bank-accounts' | translate }}</strong></div>
              </a>
            </li> -->

            <li role="menuitem">
              <a class="dropdown-item d-flex align-items-center" [routerLink]="['/profile/presets']">
                <div class="row">
                  <div class="col-auto pt-1 pr-0">
                    <i class="material-icons text-gray-600">category</i>
                  </div>
                  <div class="col">
                    <div><strong>{{ prefix + 'my-presets' | translate }}</strong></div>
                    <div class="item-text">{{ prefix + 'my-presets-text' | translate }}</div>
                  </div>
                </div>
              </a>
            </li>

            <ng-container *ngIf="cache.teams.value.length > 1">
              <li class="dropdown-divider"></li>
              <li class="px-4 text-sm"><strong>{{ prefix + 'switch-team' | translate }}</strong></li>

              <li role="menuitem" *ngFor="let t of cache.teams | async">
                <a class="dropdown-item d-flex align-items-center py-1" (click)="switchTeam(t)" href="javascript:void(0)">
                  <div class="row align-items-center">
                    <div class="col-auto pt-1 pr-0">
                      <img [src]="getTeamAvatar(t)" class="avatar">
                    </div>
                    <div class="col">
                      <div><strong>{{ t.name }}</strong></div>
                      <div class="text-gray-600" *ngIf="t.id === team.id"><em>{{ prefix + 'current-team' | translate }}</em></div>
                    </div>
                  </div>
                </a>
              </li>
            </ng-container>


            <ng-container *ngIf="isAdmin">
              <li class="dropdown-divider"></li>

              <li role="menuitem">
                <a class="dropdown-item d-flex align-items-center py-1" [routerLink]="['/admin']">
                  <div class="row align-items-center">
                    <div class="col-auto pt-1 pr-0">
                      <i class="material-icons text-gray-600">admin_panel_settings</i>
                    </div>
                    <div class="col">
                      <div><strong>{{ prefix + 'admin-panel' | translate }}</strong></div>
                    </div>
                  </div>
                </a>
              </li>
            </ng-container>

            <li class="dropdown-divider"></li>

            <li role="menuitem">
              <a class="dropdown-item d-flex align-items-center py-1" (click)="logout()" href="javascript:void(0)">
                <div class="row align-items-center">
                  <div class="col-auto pt-1 pr-0">
                    <i class="material-icons text-gray-600">exit_to_app</i>
                  </div>
                  <div class="col">
                    <div><strong>{{ prefix + 'logout' | translate }}</strong></div>
                  </div>
                </div>
              </a>
            </li>

          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="container">
  <div class="bottom-border"></div>
</div>